export default "__VITE_ASSET__cb6981bc__"